import React, { useState, useEffect } from 'react';
import './GameHome.css';

const GameHome = ({ onStartGame }) => {
  const [elements, setElements] = useState([]);
  const [erreur, setErreur] = useState(null); 

  useEffect(() => {
    const urlBackend = 'https://www.amservices.eu/api/get_users.php';

    fetch(urlBackend)
      .then((reponse) => {
        if (!reponse.ok) {
          throw new Error(`Erreur HTTP : ${reponse.status}`);
        }
        return reponse.json(); 
      })
      .then((data) => {
        setElements(data);
      })
      .catch((err) => {
        setErreur(err.message);
      });
  }, []);

  if (erreur) return <p style={{ color: 'red', padding: '20px' }}>Erreur : {erreur}</p>;
  
  // --- FILTRES DES DEUX TABLEAUX ---
  const joueursGeneraux = elements.filter(p => p.type !== "@amservices.eu");
  const techniciensAM = elements.filter(p => p.type === "@amservices.eu");

  return (
    <div className="home-landing">
      {/* Zone de présentation principale / Hero section */}
      <section className="hero-presentation">
        <h2>Tech Runner</h2>
        <p>
          Évitez les obstacles, récupérez les bonus et enregistrez votre meilleur score 
          pour tenter de gagner des lots chez Am Services.
        </p>
        <button onClick={onStartGame} className="btn-launch-game">
          <span>JOUER</span>
          <svg viewBox="0 0 24 24" className="svg-icon-btn">
            <path d="M2 12h18M14 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </section>

      {/* Grille principale */}
      <div className="landing-grid">
        
        {/* Section de gauche : Instructions détaillées */}
        <section className="guide-section">
          <h3 className="section-title">
            <svg viewBox="0 0 24 24" className="svg-title-icon">
              <path d="M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M16 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" fill="currentColor"/>
              <path d="M6 8h2M6 12h2M6 16h2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            Comment jouer
          </h3>

          {/* LES COMMANDES */}
          <div className="guide-category">
            <h4>Commandes du jeu</h4>
            <div className="items-list">
              
              {/* Bloc Sauter (Clavier) */}
              <div className="guide-card controls-card">
                <div className="kbd-container">
                  <kbd className="kbd-key wide">Espace</kbd>
                  <span className="kbd-or">ou</span>
                  <kbd className="kbd-key">↑</kbd>
                </div>
                <div className="card-text">
                  <h5>Sauter (Sur PC)</h5>
                  <p>Esquive les obstacles au sol (Serveurs, Barrières, Câbles).</p>
                </div>
              </div>

              {/* Bloc Glisser (Clavier) */}
              <div className="guide-card controls-card">
                <div className="kbd-container">
                  <kbd className="kbd-key">↓</kbd>
                </div>
                <div className="card-text">
                  <h5>Glisser (Sur PC)</h5>
                  <p>Passe sous les obstacles aériens (Wi-Fi, Drones).</p>
                </div>
              </div>

              {/* BLOC EXCLUSIF SUR MOBILE & TABLETTE */}
              <div className="guide-card controls-card mobile-only-card">
                <div className="kbd-container">
                  <svg viewBox="0 0 24 24" className="svg-touch-icon" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
                    <path d="M5 5h14M5 19h14" />
                    <line x1="10" y1="3.5" x2="14" y2="3.5" />
                    <circle cx="12" cy="20.5" r="0.5" fill="currentColor" />
                  </svg>
                </div>
                <div className="card-text">
                  <h5>Jouer sur Mobile / Tablette</h5>
                  <p>Appuie simplement sur l'écran de jeu pour faire sauter le technicien et éviter les obstacles !</p>
                </div>
              </div>

            </div>
          </div>

          {/* LES OBSTACLES */}
          <div className="guide-category">
            <h4>Obstacles à éviter (Game Over)</h4>
            <div className="items-list">
              <div className="guide-card obstacle-card">
                <img src="/assets/obs_server.png" alt="Serveur" />
                <div className="card-text">
                  <h5>Serveur</h5>
                  <p>Obstacle au sol. Sautez par-dessus (Espace ou ↑).</p>
                </div>
              </div>
              <div className="guide-card obstacle-card">
                <img src="/assets/obs_barrier.png" alt="Barrière" />
                <div className="card-text">
                  <h5>Barrière</h5>
                  <p>Obstacle au sol. Sautez par-dessus (Espace ou ↑).</p>
                </div>
              </div>
              <div className="guide-card obstacle-card">
                <img src="/assets/obs_cable.png" alt="Câble" />
                <div className="card-text">
                  <h5>Câble</h5>
                  <p>Obstacle au sol. Sautez par-dessus (Espace ou ↑).</p>
                </div>
              </div>
              <div className="guide-card obstacle-card">
                <img src="/assets/obs_wifi.png" alt="Wifi" />
                <div className="card-text">
                  <h5>Signal Wi-Fi</h5>
                  <p>Obstacle aérien. Restez au sol ou glissez (↓).</p>
                </div>
              </div>
              <div className="guide-card obstacle-card">
                <img src="/assets/obs_drone.png" alt="Drone" />
                <div className="card-text">
                  <h5>Drone</h5>
                  <p>Obstacle aérien bas. Restez au sol ou glissez (↓).</p>
                </div>
              </div>
            </div>
          </div>

          {/* LES BONUS AVEC NOUVELLES DESCRIPTIONS TECH */}
          <div className="guide-category">
            <h4>Bonus à ramasser (+200 points)</h4>
            <div className="items-list">
              
              {/* Clé USB */}
              <div className="guide-card bonus-card">
                <img src="/assets/bonus_usb.png" alt="USB" />
                <div className="card-text">
                  <h5>Clé USB</h5>
                  <p>Injecte un script d'extension système pour exécuter un saut double</p>
                </div>
              </div>
              
              {/* Routeur */}
              <div className="guide-card bonus-card">
                <img src="/assets/bonus_router.png" alt="Routeur" />
                <div className="card-text">
                  <h5>Routeur</h5>
                  <p>Augmente la bande passante : les données arrivent 2x plus vite, doublant la vitesse du score.</p>
                </div>
              </div>

              {/* NOUVEAU : Bouclier */}
              <div className="guide-card bonus-card">
                <img src="/assets/bonus_shield.png" alt="Bouclier" />
                <div className="card-text">
                  <h5>Bouclier</h5>
                  <p>Déploie un pare-feu matériel (Firewall) capable de neutraliser et d'effacer le prochain obstacle rencontré.</p>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* Section de droite : Classement global */}
        <section className="global-scoreboard">
          <h3 className="section-title">
            <svg viewBox="0 0 24 24" className="svg-title-icon trophy">
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6M18 9h1.5a2.5 2.5 0 0 0 0-5H18M4 22h16M10 14.66V17c0 .55-.45 1-1 1H4v2h16v-2h-5c-.55 0-1-.45-1-1v-2.34" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 2a6 6 0 0 1 6 6v5a6 6 0 0 1-6 6 6 6 0 0 1-6-6V8a6 6 0 0 1 6-2Z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Classement général
          </h3>
          <div className="leaderboard-table">
            {!joueursGeneraux.length ? (
              <div className="leaderboard-empty">
                <p>Aucun gagnant... Jouez et tentez votre chance !</p>
              </div>
            ) : (
              joueursGeneraux.slice(0, 5).map((player, index) => (
                <div key={player.id || index} className="leaderboard-row">
                  <span className="player-rank">#{index + 1}</span>
                  <span className="player-name">{player.name}</span>
                  <span className="player-score">
                    {player.score ? Number(player.score).toLocaleString() : 0} pts
                  </span>
                </div>
              ))
            )}
          </div>
          
          {/* TABLEAU 2 : CLASSEMENT INTERNE AM SERVICES */}
          <div className="table-wrapper">
            <h3 className="scoreboard-main-title lime-title">
              <svg viewBox="0 0 24 24" className="svg-title-icon trophy-lime">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              LES TECHNICIENS AM SERVICES
            </h3>
            <div className="leaderboard-table-premium">
              {!techniciensAM.length ? (
                <div className="leaderboard-empty-premium">
                  <p>Aucun technicien n'a encore enregistré son score.</p>
                </div>
              ) : (
                techniciensAM.slice(0, 5).map((player, index) => (
                  <div 
                    key={player.id || index} 
                    className={`leaderboard-card-row staff-rank`}
                  >
                    <div className="rank-badge-wrap">
                      <span className="player-rank-badge staff">#{index + 1}</span>
                    </div>
                    <span className="player-name-text">{player.name}</span>
                    <span className="player-score-digital">
                      {player.score ? Number(player.score).toLocaleString() : 0} <small>pts</small>
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default GameHome;